import { Copy, UserMinus, UserPlus } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { formatError, useAuth } from "@/auth";
import { Avatar } from "@/components/projects/common";

export function MembersTab({ project, onChanged }) {
  const { user } = useAuth();
  const internal = user.role !== "guest";
  const [directory, setDirectory] = useState([]);
  const [pick, setPick] = useState("");
  const [guest, setGuest] = useState({ email: "", name: "" });
  const [link, setLink] = useState("");
  useEffect(() => { if (internal) api.get("/project-directory").then(({ data }) => setDirectory(data)).catch(() => {}); }, [internal]);
  const add = async (payload) => {
    try {
      const { data } = await api.post(`/projects/${project.id}/members`, { ...payload, app_url: window.location.origin });
      if (data.invite_link) { setLink(data.invite_link); toast.success("Invitation envoyée par e-mail."); } else toast.success("Membre ajouté.");
      setPick(""); setGuest({ email: "", name: "" }); onChanged();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  const remove = async (m) => { if (window.confirm(`Retirer ${m.name} du projet ?`)) { await api.delete(`/projects/${project.id}/members/${m.id}`); onChanged(); } };
  const available = directory.filter((d) => !project.members.includes(d.id));
  return (
    <div data-testid="members-tab">
      <ul className="pj-members">
        {project.members_info.map((m) => (
          <li key={m.id} data-testid={`member-${m.id}`}>
            <Avatar name={m.name} size={36} />
            <div><strong>{m.name}</strong><small>{m.email}</small></div>
            <span className={`pj-pill ${m.role === "guest" ? "is-guest" : ""}`}>{m.role === "guest" ? (m.invite_pending ? "Invité · en attente" : "Invité externe") : m.role === "admin" ? "Administrateur" : "Équipe"}</span>
            {internal && m.id !== user.id && <button type="button" className="pj-icon-btn" onClick={() => remove(m)} aria-label="Retirer" data-testid={`member-remove-${m.id}`}><UserMinus size={16} /></button>}
          </li>
        ))}
      </ul>
      {internal && (
        <div className="pj-member-forms">
          <form className="pj-box pj-form" onSubmit={(e) => { e.preventDefault(); if (pick) add({ user_id: pick }); }}>
            <h4>Ajouter un membre de l'équipe</h4>
            <select value={pick} onChange={(e) => setPick(e.target.value)} data-testid="member-pick"><option value="">Choisir…</option>{available.map((d) => <option key={d.id} value={d.id}>{d.name} — {d.email}</option>)}</select>
            <button type="submit" className="secondary-button" disabled={!pick} data-testid="member-add-btn"><UserPlus size={15} />Ajouter</button>
          </form>
          <form className="pj-box pj-form" onSubmit={(e) => { e.preventDefault(); add(guest); }}>
            <h4>Inviter une personne externe</h4>
            <input placeholder="Nom" value={guest.name} onChange={(e) => setGuest({ ...guest, name: e.target.value })} data-testid="guest-name" />
            <input type="email" placeholder="E-mail *" value={guest.email} onChange={(e) => setGuest({ ...guest, email: e.target.value })} required data-testid="guest-email" />
            <button type="submit" className="primary-button" data-testid="guest-invite-btn"><UserPlus size={15} />Envoyer l'invitation</button>
            {link && <div className="pj-invite-link" data-testid="guest-invite-link"><span>{link}</span><button type="button" className="pj-icon-btn" onClick={() => { navigator.clipboard?.writeText(link); toast.success("Lien copié."); }} aria-label="Copier" data-testid="guest-invite-copy"><Copy size={15} /></button></div>}
            <small className="pj-sub">L'invité n'accède qu'aux projets auxquels il est ajouté.</small>
          </form>
        </div>
      )}
    </div>
  );
}
